import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import {
  AssetTreeAdminModeBadgeType,
  AssetTreeViewComponent,
  provideAssetTreeSettings,
  provideTopicsTreeMode,
} from '@examdojo/topics-tree';
import { TopicStatusBadgeComponent } from './tree-badges/topic-status-badge.component';

@Component({
  selector: 'exam-syllabus',
  imports: [AssetTreeViewComponent, RouterOutlet],
  templateUrl: './syllabus.component.html',
  styleUrl: './syllabus.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    provideAssetTreeSettings(),
    provideTopicsTreeMode('admin', { [AssetTreeAdminModeBadgeType.AssetStatus]: TopicStatusBadgeComponent }),
  ],
})
export class SyllabusComponent {
  // Topics data is now loaded by the syllabusTopicsResolver
}
